import { DataTable } from "@suns/design-system/src/components/DataTable/DataTable";
import { useState } from "react";

import { playersLoader } from "@/pages/players/loaders/player-loader";
import { useAsync } from "@/shared/hooks";
import { Link, useNavigate } from "react-router-dom";
import { SortingState } from "@tanstack/react-table";
import { Flex } from "@suns/design-system/src/components/Flex/Flex";
import { defaultRosterColumns } from "@/pages/players/players-columns";
import { Text } from "@suns/design-system";

export function TeamRoster({
  teamId,
  leagueId,
}: {
  teamId: string;
  leagueId: number;
}) {
  const navigate = useNavigate();

  const [sortingColumns, setSortingColumns] = useState<SortingState>([
    {
      id: "name",
      desc: false,
    },
  ]);
  const [paginationValues, setPaginationValues] = useState({
    pageIndex: 0,
    pageSize: 20,
  });

  const pagination = {
    pageIndex: paginationValues.pageIndex,
    pageSize: paginationValues.pageSize,
  };

  const { response, loading: playersLoading } = useAsync(playersLoader, {
    currentTeams: [teamId],
    offset: pagination.pageIndex * pagination.pageSize,
    limit: pagination.pageSize,
    sortColumn: sortingColumns[0]?.id,
    sortDir: sortingColumns[0]?.desc ? "DESC" : "ASC",
  });

  const handleSelectPlayer = (id: number | null) => {
    if (!id) return;
    navigate(`/players/${id}`);
  };

  return (
    <Flex direction="down" gap="md">
      <Flex direction="right" align="center" justify="between">
        <Text variant="muted" heading>
          Roster
        </Text>
        <Link
          to={`/players?team.in=${teamId}&league.in=${leagueId}`}
          className="text-sm font-semibold text-primary"
        >
          View All Filters
        </Link>
      </Flex>
      <DataTable
        loading={playersLoading}
        columns={defaultRosterColumns}
        data={response?.players || []}
        count={response?.count || 0}
        pagination={pagination}
        setPagination={(setPagination) => {
          const newPagination =
            typeof setPagination === "function"
              ? setPagination(pagination)
              : setPagination;

          setPaginationValues(newPagination);
        }}
        sorting={sortingColumns}
        setSorting={(setSorting) => {
          const newSort =
            typeof setSorting === "function"
              ? setSorting(sortingColumns)
              : setSorting;

          const sort = newSort[0] ?? null;

          setSortingColumns([
            {
              // @ts-expect-error - DO NOT COPY THIS LINE
              id: sort.id,
              // @ts-expect-error - DO NOT COPY THIS LINE
              desc: sort.desc,
            },
          ]);
        }}
        onRowClicked={(row) => handleSelectPlayer(row.original.id)}
      />
    </Flex>
  );
}
